import './UserProfileCarousel.css'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import { useContext } from 'react'
import AppContext from '../../../contexts/AppContext'
import { Image } from '@mantine/core'
import {useConfigContext} from "../../../contexts/ConfigContext/ConfigContextProvider";

export default function UserProfileCarousel() {
   const { currentUser } = useContext(AppContext)
    const { jsonMedia } = useConfigContext();

   const petLiked = currentUser?.animalType ?? 'dog'
   const title = `Porque te gustan los paisajes ${petLiked === 'cat' ? 'rurales' : 'urbanos'}`
   return (
      <section className='UserProfileCarousel-container'>

         <h5 className='UserProfileCarousel--title'>{title}</h5>

         <Splide className='UserProfileCarousel--carousel' aria-label="Carrusel de imagenes" options={{
            rewind: true,
            autoplay: true
         }} >
            {jsonMedia?.userPreferences[petLiked]?.map(img => (
               <SplideSlide >
                  <Image
                     radius="var(--border-radius-sm)"
                     src={img}
                     h='100%'
                     fallbackSrc="https://placehold.co/600x400?text=Imagen"
                  />
               </SplideSlide>
            ))}

         </Splide>
      </section>
   )
}
